import styled from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden';
import { colors } from 'theme';

export const TabSwitcherTabInput = styled.input`
  ${visuallyHiddenCss}

  &:checked + label {
    color: ${colors.brandBlue};
  }
`;

export const TabSwitcherTabLabel = styled.label<{
  $compact: boolean;
}>`
  user-select: none;
  display: inline-block;
  padding-bottom: ${(props) => (props.$compact ? 8 : 16)}px;
  padding-left: ${(props) => (props.$compact ? 0 : 16)}px;
  padding-right: ${(props) => (props.$compact ? 0 : 16)}px;
  background: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  text-wrap: nowrap;
  transition: var(--transition);
  position: relative;

  color: ${colors.lightContentGrey};

  &:hover {
    border-bottom: 2px solid ${colors.lightContentGrey};
  }
`;
